import {CLOSE_ALERT} from '../Actions/AlertMessage.action';
const defaultState = "";
export const shopAlertMessage = (state = defaultState, action) => {
    switch (action.type) {
        case CLOSE_ALERT: 
            return defaultState;
        default:
            return state;
    }
}